import globalStore from '$$globalStore';
import timeTrackingModel from '$$timeTrackingModel';
import constants from '$$helpers/constants';

export default function (taskId, ganttId) {
  const taskChildren = globalStore.getters['tasksModel/getAllChildByTask'](ganttId, taskId);
  let total = 0;

  taskChildren.forEach(childTask => {
    if (childTask.type !== constants.TASK_TYPES.button) {
      const logsData = timeTrackingModel.getLogsByParamsNotCopy(childTask.gantt_id, childTask.id);

      total += logsData ? logsData.sum : 0;
    }
  });

  return total;
}
